import $ from "jquery";

import "datatables.net";

import { BACKEND_CONFIG } from "../config/consts";
import amexIcon from "../images/amex.svg";
import discoverIcon from "../images/discover.svg";
import mastercardIcon from "../images/mastercard.svg";
import visaIcon from "../images/visa.svg";

import FormatUtils from "./formatUtils";
import { escape } from "./utils";

import "../styles/_datatables.scss";

export const getUrlParams = (queryString) => {
  var vars = {};
  window.location.href.replace(
    /[?&]+([^=&]+)=([^&]*)/gi,
    function (m, key, value) {
      vars[key] = value;
    }
  );

  return vars;
};

export const configureDataTable = () => {
  $.extend(true, $.fn.dataTable.defaults, {
    dom:
      "<'row no-gutters w-100'<'w-100'tr>>" +
      "<'row justify-content-between align-items-top w-100 ml-0 mr-0'<'col-auto mr-auto p-0'l><'col-auto ml-auto p-0'p>>",
    bInfo: false,
    language: {
      paginate: {
        previous:
          '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48">< g fill="none" fill-rule="evenodd"><path fill="none" d="M0 0h48v48H0z" /><path fill="#000" stroke="#2B2A3A" d="M30.662 39a.666.666 0 0 1-.46-.183L17.057 26.445A3.322 3.322 0 0 1 16 24c0-.936.375-1.804 1.057-2.445L30.202 9.183a.671.671 0 1 1 .92.978L17.978 22.532c-.409.385-.634.907-.634 1.468 0 .562.225 1.083.634 1.468l13.146 12.371a.672.672 0 0 1-.46 1.161" /></g></svg>',
        next: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48">< g fill="none" fill-rule="evenodd"><path fill="none" d="M0 0h48v48H0z" /><path fill="#000" stroke="#2B2A3A" d="M16.671 39a.67.67 0 0 1-.46-1.16l13.145-12.372c.41-.385.634-.906.634-1.468 0-.561-.224-1.083-.634-1.468L16.211 10.161a.672.672 0 1 1 .922-.978l13.144 12.372A3.322 3.322 0 0 1 31.334 24c0 .936-.375 1.805-1.057 2.445L17.133 38.817a.668.668 0 0 1-.462.183" /></g></svg>',
      },
      search: "",
    },
  });
};

export const renderArchived = (data, type, full) => {
  var isChecked = data ? " checked" : "";
  var string =
    '<input type="checkbox" data-clientid="' +
    full.id +
    '" class="cb-is-archived" ' +
    isChecked +
    "></input>";

  return string;
};

export const renderBusinessName = (data, type, full) => {
  if (full.isNotPreSubmittedProspect) {
    return `<a href="/client/` + full.id + `">` + escape(data) + `</a>`;
  }

  var submitLink = full.uaUrl + "api/primary_ua/resume/" + full.id;
  var formId = "form_" + full.id;

  return (
    "<form id=" +
    formId +
    " action=" +
    submitLink +
    ' method="post">' +
    '<input type="hidden" name="token" value=' +
    BACKEND_CONFIG.get("auth") +
    "></input>" +
    "<a href='/' onclick='document.getElementById(`" +
    formId +
    "`).submit(); return false;'>" +
    data +
    "</a>" +
    "</form>"
  );
};

export const renderOrderStatus = (data, type, full) => {
  var status = full.Status;

  switch (status) {
    case "Accepted":
      return status + "-" + FormatUtils.formatDate(full.StatusDate);
    case "Rejected":
      return (
        status +
        "-" +
        FormatUtils.formatDate(full.StatusDate) +
        "-" +
        full.Reason
      );
    default:
      return status;
  }
};

export const extractListItemsFromResponse = (data, listName) => {
  return data.data.filter((d) => d.Key === listName)[0].Value;
};

export const renderPaymentOption = (data, type, full) => {
  if (full.PaymentOption === "Credit / Debit Card") {
    switch (full.CardCompany) {
      case "masterCard":
        return (
          "<img src='" + mastercardIcon + "' /> Ending in " + full.LastFourOfPAN
        );
      case "americanExpress":
        return "<img src='" + amexIcon + "' /> Ending in " + full.LastFourOfPAN;
      case "discover":
        return (
          "<img src='" + discoverIcon + "' /> Ending in " + full.LastFourOfPAN
        );
      case "visa":
        return "<img src='" + visaIcon + "' /> Ending in " + full.LastFourOfPAN;
      default:
        return `Credit / Debit Card Ending in ${full.LastFourOfPAN}`;
    }
  } else if (full.PaymentOption === "ACH") {
    return `ACH Ending in ${full.LastFourOfPAN}`;
  }
};

export const loadScript = (src, isAsync) => {
  const script = document.createElement("script");
  script.src = src;
  script.async = isAsync;
  document.body.appendChild(script);
};

export const removeZMarkers = (str) => str.replace("Z", "");
